import React from 'react';
import { Grid, Container, Box } from '@material-ui/core';
import { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import Typewriter from 'typewriter-effect';
import MyImg from '../../Attachments/My Img.jpg';

const Home = () => {
    const [index, setIndex] = useState(0);

    const handleSelect = (selectedIndex, e) => {
        setIndex(selectedIndex);
    };

    return (
        <div>
            {/* Top Section */}
            <Box sx={{ m: 4 }} >
                <Container>
                    <Grid container  >
                        <Grid item xs={12} md={6} className='banner-texts'>
                            <h2>I am a<span style={{ color: 'rgb(138, 224, 102)' }}>
                                {/* style={{ color: 'rgb(255, 109, 12)' }}> */}
                                <Typewriter
                                    options={{
                                        strings: ['React Developer', 'Jr. Full-Stack Web Developer', 'MERN Stack Developer', 'UI & UX Designer', 'Programmer🔥'],
                                        autoStart: true,
                                        loop: true,
                                    }}
                                /></span>
                            </h2>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Carousel fade activeIndex={index} onSelect={handleSelect} /*variant="dark"*/>
                                <Carousel.Item interval={3000}>
                                    <img
                                        className="d-block w-50 m-auto"
                                        src={MyImg}
                                        alt="First slide"
                                    />
                                    <Carousel.Caption>
                                        {/* <h3></h3>
                                        <p></p> */}
                                    </Carousel.Caption>
                                </Carousel.Item>
                                <Carousel.Item interval={3000}>
                                    <img
                                        className="d-block w-50 m-auto"
                                        src={MyImg}
                                        alt="Second slide"
                                    />
                                    <Carousel.Caption>
                                        {/* <h3></h3>
                                        <p></p> */}
                                    </Carousel.Caption>
                                </Carousel.Item>
                            </Carousel>
                            {/* <img src={MyImg} width='50%' alt="me" /> */}
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </div >
    );
};

export default Home;